import React, { memo } from 'react';
import { Wand2, Loader2 } from 'lucide-react';
import { NodeStatus } from '@/types';

interface GenerateButtonProps {
  status: NodeStatus;
  onClick: () => void;
  disabled?: boolean;
}

const GenerateButtonInner: React.FC<GenerateButtonProps> = ({
  status,
  onClick,
  disabled = false,
}) => {
  const isWorking = status === NodeStatus.WORKING;

  return (
    <button
      onClick={onClick}
      disabled={isWorking || disabled}
      className={`relative flex items-center gap-2 px-4 py-1.5 rounded-[12px] font-bold text-[10px] tracking-wide transition-all duration-300 ${
        isWorking || disabled
          ? 'bg-white/5 text-slate-500 cursor-not-allowed'
          : 'bg-gradient-to-r from-cyan-500 to-blue-500 text-black hover:shadow-lg hover:shadow-cyan-500/20 hover:scale-105 active:scale-95'
      }`}
    >
      {isWorking ? (
        <Loader2 className="animate-spin" size={12} />
      ) : (
        <Wand2 size={12} />
      )}
      <span>{isWorking ? '生成中...' : '生成'}</span>
    </button>
  );
};

export const GenerateButton = memo(GenerateButtonInner, (prevProps, nextProps) => {
  return (
    prevProps.status === nextProps.status &&
    prevProps.disabled === nextProps.disabled
  );
});